module.exports = __webpack_public_path__ + "static/media/LB_04.451424e8.jpg";